import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { routeList } from "./App";
import { storageKey } from "./configs/config";
import LoadingPage from "./pages/Loading.page";
import api from "./services/api";
import { useUserStore } from "./store/useUserStore";

export const ProtectedRoute = () => {
  const isFirstVisit = localStorage.getItem("isFirstVisit");
  const accessToken = localStorage.getItem(storageKey.accessToken);
  const refreshToken = localStorage.getItem("refreshToken");

  if (!isFirstVisit) return <Navigate to="/" replace />;
  else if (isTokenValid(accessToken) || isTokenValid(refreshToken)) {
    return <Navigate to={routeList.addPictures} replace />; // ✅ Redirect if logged in
  } else return <Outlet />; // ✅ Otherwise, show public page
};

export const PrivateRoute = () => {
  const isFirstVisit = localStorage.getItem("isFirstVisit");
  const accessToken = localStorage.getItem(storageKey.accessToken);
  const refreshToken = localStorage.getItem(storageKey.refreshToken);

  if (!isFirstVisit) return <Navigate to="/" replace />;
  else if (!isTokenValid(accessToken) && !isTokenValid(refreshToken)) {
    return <Navigate to="/" replace />; // ✅ Redirect if logged in
  } else return <Outlet />; // ✅ Otherwise, show public page
};

const isTokenValid = (token: string | null): boolean => {
  if (!token) return false;

  try {
    const decoded: { exp: number } = jwtDecode(token);
    return decoded.exp * 1000 > Date.now(); // ✅ Check if token is still valid
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const ProfileRoute = () => {
  const [isLoading, setIsloading] = useState<boolean>(true);
  const { setProfile } = useUserStore();
  const navigate = useNavigate();

  const fetchProfile = async () => {
    try {
      const response = await api.getProfile();
      const profile = response.data;
      setProfile(profile);
      const { imageUrls, traits, birthDate, youRole, themRole, ageFrom, ageTo } = profile;
      if (imageUrls.length == 0) navigate(routeList.addPictures);
      else if (traits.length == 0) navigate(routeList.aboutThem);
      else if ([birthDate, youRole, themRole, ageFrom, ageTo].some((e) => e == null))
        navigate(routeList.aboutYouConnectWith);
      else if (profile.accountVerificationSubmitted == false && profile.accountVerified == false) {
        navigate(routeList.verifyAccount);
      }
      setIsloading(false);
    } catch (err) {
      console.log("Error fetching profile", err);
      alert("Error fetching profile");
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  if (isLoading) return <LoadingPage />;
  else return <Outlet />;
};
